(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[582],{

/***/ 20582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ components_GainCompleteViewOfYourCustomers_GainCompleteViewOfYourCustomers; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/GainCompleteViewOfYourCustomers/assets/GainCompleteViewOfYourCustomers@2x.png
var GainCompleteViewOfYourCustomers_2x = __webpack_require__(10425);
var GainCompleteViewOfYourCustomers_2x_default = /*#__PURE__*/__webpack_require__.n(GainCompleteViewOfYourCustomers_2x);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/GainCompleteViewOfYourCustomers/assets/GainCompleteViewOfYourCustomers.webp
var GainCompleteViewOfYourCustomers = __webpack_require__(64637);
var GainCompleteViewOfYourCustomers_default = /*#__PURE__*/__webpack_require__.n(GainCompleteViewOfYourCustomers);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/GainCompleteViewOfYourCustomers/assets/GainCompleteViewOfYourCustomers@2x.webp
var assets_GainCompleteViewOfYourCustomers_2x = __webpack_require__(91902);
var assets_GainCompleteViewOfYourCustomers_2x_default = /*#__PURE__*/__webpack_require__.n(assets_GainCompleteViewOfYourCustomers_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/GainCompleteViewOfYourCustomers/GainCompleteViewOfYourCustomersImage.tsx







var SIZES = "640px, 1280px";

var GainCompleteViewOfYourCustomersImage = function GainCompleteViewOfYourCustomersImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((GainCompleteViewOfYourCustomers_default()), " 640w, ").concat((assets_GainCompleteViewOfYourCustomers_2x_default()), " 1280w"),
        sizes: SIZES
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        src: (GainCompleteViewOfYourCustomers_2x_default()),
        sizes: SIZES,
        alt: "Orchestrate Journeys",
        width: "640",
        height: "478",
        loading: "lazy"
      })]
    })
  });
};

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1y776350"
} : 0)("display:flex;flex-direction:column;justify-content:center;align-items:center;padding:0px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{height:100%;}" + ( true ? "" : 0));

/* harmony default export */ var GainCompleteViewOfYourCustomers_GainCompleteViewOfYourCustomersImage = (GainCompleteViewOfYourCustomersImage);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/GainCompleteViewOfYourCustomers/GainCompleteViewOfYourCustomers.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var copy = {
  heading: "Gain a complete view of your customers",
  description: "Get complete, identity-resolved customer profiles in real time and easily build precise audiences in a privacy-first way to deliver personalized customer experiences at scale."
};
var GainCompleteViewOfYourCustomers_link = {
  text: "Explore Unify",
  url: "/product/unify/"
};
var features = [{
  heading: "Build dynamic audiences off of real-time complete profiles",
  description: "Craft audiences without SQL expertise, with real-time customer interactions including behaviors, traits, and intent signals."
}, {
  heading: "Know your customer in a privacy-first way",
  description: "Profiles are built with consented data collection and activation for privacy-first personalization across channels."
}, {
  heading: "Discover new engagement opportunities",
  description: "Identify new customer insights and behavioral patterns to uncover untapped opportunities for engagement in real time."
}];

var GainCompleteViewOfYourCustomers_GainCompleteViewOfYourCustomers = function GainCompleteViewOfYourCustomers() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionWrapper, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionCopy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          gap: "small",
          children: features.map(function (feature, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
              alignment: "left",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: feature.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: feature.description
                })]
              })
            }, index);
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
        href: (0,getAbsoluteUrl/* default */.Z)(GainCompleteViewOfYourCustomers_link.url, pageConfig),
        children: GainCompleteViewOfYourCustomers_link.text
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GainCompleteViewOfYourCustomers_GainCompleteViewOfYourCustomersImage, {})
    })]
  });
};

var SectionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "el75bl72"
} : 0)( true ? {
  name: "ajfln6",
  styles: "overflow-x:visible"
} : 0);

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "el75bl71"
} : 0)("direction:ltr;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;max-width:440px;}" + ( true ? "" : 0));

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "el75bl70"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

/* harmony default export */ var components_GainCompleteViewOfYourCustomers_GainCompleteViewOfYourCustomers = (GainCompleteViewOfYourCustomers_GainCompleteViewOfYourCustomers);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/GainCompleteViewOfYourCustomers/index.ts


/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 10425:
/***/ (function(module) {

module.exports = "/_next/static/images/GainCompleteViewOfYourCustomers@2x-82e738fa4970de1446dceafc160b3104.png";

/***/ }),

/***/ 64637:
/***/ (function(module) {

module.exports = "/_next/static/images/GainCompleteViewOfYourCustomers-eaaee3292a2a207c14e2d550effa503c.webp";

/***/ }),

/***/ 91902:
/***/ (function(module) {

module.exports = "/_next/static/images/GainCompleteViewOfYourCustomers@2x-64ddd3c4af437f66befda471b25b20a5.webp";

/***/ })

}]);